import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './en/translation.json';
import uaTranslation from './ua/translation.json';
import esTranslation from './es/translation.json';
import frTranslation from './fr/translation.json';
import trTranslation from './tr/translation.json';
import jaTranslation from './ja/translation.json';
import koTranslation from './ko/translation.json';
import ptTranslation from './pt/translation.json';

export const listOfLang = ['uk', 'ua', 'en', 'ko', 'us', 'es', 'fr', 'tr', 'ja', 'pt']

i18next.use(initReactI18next).init({
    lng: 'en', // if you're using a language detector, do not define the lng option
    debug: true,
    resources: {
        en: {
            translation: enTranslation,
        },
        ua: {
           translation: uaTranslation,
        },
        es: {
            translation: esTranslation,
        },
        fr: {
            translation: frTranslation,
        },
        tr: {
            translation: trTranslation,
        },
        ja: {
            translation: jaTranslation,
        },
        ko: {
            translation: koTranslation,
        },
        pt: {
            translation: ptTranslation,
        }
    },
    // if you see an error like: "Argument of type 'DefaultTFuncReturn' is not assignable to parameter of type xyz"
    // set returnNull to false (and also in the i18next.d.ts options)
    // returnNull: false,
});
